import find from 'lodash/fp/find';

export const nextWithSections = find(item => item.sectionBegin !== null);
